import React from 'react';
import { IWidgetOption } from '../../../../Widget';
import { WidgetOptionDividerView } from './WidgetOptionDividerView';
import { WidgetOptionValueView } from './WidgetOptionValueView';

export interface IWidgetOptionViewProps {
  item: IWidgetOption;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function WidgetOptionView(props: IWidgetOptionViewProps) {
  if (!props.item) return null;
  switch (props.item.type) {
    case 'option':
      return <WidgetOptionValueView {...props} item={props.item} />;
    case 'divider':
      return <WidgetOptionDividerView {...props} item={props.item} />;
  }
}
